

  const temp_url = "/xcsfvt"
  export const Routers= {
    PageNotFound:"*",
    Home:temp_url,
    site2:temp_url + "/site-one",
    site1:temp_url + "/site-two",
    CorporateSiteOne:temp_url + "/corporate-site-one",
    CorporateSiteTwo:temp_url + "/corporate-site-two",
    LandingPage:temp_url + "/referal-code/:referralId",
    WhyKeyzi:temp_url + "/why-keyzi",
    OurInstructor:temp_url + "/instructor",
    School:temp_url + "/school-detail",
    SignUpLearner:temp_url + "/signup-learner",
    SignUpInstructor:temp_url + "/signup-instructor",
    Contact:temp_url + "/contact",
    Manual:temp_url + "/driving-instructors",
    ManualCity:temp_url + "/driving-instructors/:state/:city",
    ManualState:temp_url + "/driving-instructors/:state",
    MoreInfo:temp_url + "/more-info/:id",
    Login:temp_url + "/login",
    ForgotPasword:temp_url + "/login/forgot-password",
    ResetPassoword:temp_url + "/login/reset-password",
    Progress:temp_url + "/auth/progress",
    JoinKeyzi:temp_url + "/join-keyzi",
    Dashboard:temp_url + "/auth/dashboard",
    Profile:temp_url + "/auth/dashboard/profile",
    ChangePassword:temp_url + "/auth/dashboard/password",
    Wallet:temp_url + "/auth/dashboard/wallet",
    Booking:temp_url + "/auth/dashboard/booking",
    bookingDetails:temp_url + "/auth/dashboard/booking/booking-details/:id",
    updateBooking:temp_url + "/auth/dashboard/booking/booking-details/update-booking/:id",
    feedbacklearner:temp_url + "/auth/dashboard/booking/booking-details/rating/:id",
    Transaction:temp_url + "/auth/dashboard/transaction",
    // findanInstructor:temp_url + "/findanInstructor/:state",
    // findanInstructor:temp_url + "/findanInstructor",
    // conquer:temp_url + "/test-packages",
    unlock:temp_url + "/parents-manual",
    // embark:temp_url + "/driving-lessons",
    guide:temp_url + "/diy-vs-driving-instructor",
    rediscover: temp_url + "/refresher-driving-lesson",
    license: temp_url + "/international-drivers-licence-conversions",
    navigating: temp_url + "/licensing-requirements-in-australia",
    support: temp_url + "/support",
    supportDetails: temp_url + "/support-content/:type/",
    supportDetailscontent:temp_url + "/support-content/:type/:articleId",
    drivinglessonsnew:temp_url + "/driving-lessons",
    testPackagesnew:temp_url + "/test-packages",
    giftvoucher:temp_url + "/gift-voucher",
    becomeAInstructor:temp_url + "/become-a-driving-instructor",
    internationalsConversions:temp_url + "/internationals-conversions",
    refresherCourses:temp_url + "/refresher-courses"
    }